
import {shoppingCart, claimQuickConceptionPackageClicked} from './cart'



// =========================================================
//        | QUICK CONCEPTION PACKAGES UI CONTROLLER |
// =========================================================
// (If on a page they aren't available, there won't be any errors. We are using arrays from querySellectorAll)

export function InitializeQuickConceptionPackagesControls() {

    
    document.querySelectorAll('.quick-conception-packages').forEach(item => {
        // Get all quick conception packages using .quick-conception-packages (We have two of it's kind)
        // Loop over them, use the data-package values of their child .package-details-container to set the prices and 
        // Get their data-package as the QuickConception Package Code
        let quickConceptionPackage = item;
        setUpQuickConceptionPackageDetailsPlusEventListeners(quickConceptionPackage)
    });


    // Add Event Listener to Claim Quick Selection Package button (Not using closure for item)
    document.querySelectorAll('.claim-quick-conception-package').forEach(item => {
        item.addEventListener('click', claimQuickConceptionPackageClicked);
    });


    // Activate VIP three cycles by default
    let Vip3CyclesPackage = document.querySelector('.qc-three-cycles-vip-package ')

    if (Vip3CyclesPackage != null) {
        Vip3CyclesPackage.click();
    }

}


function setUpQuickConceptionPackageDetailsPlusEventListeners(quickConceptionPackage) {

    // Add a click even listener on each .package-details-container

    //   When a click or tap occurs on any of them, loop through all of them and switch their icons 
    //  to unselected and remove border child .package-duration-text

    //  Finally set selected icon for clicked or tapped item 
    //  Also set the border for it's child .package-duration-text


    // query the .package-details-container in each quick-conception-packages
    quickConceptionPackage.querySelectorAll('.package-details-container').forEach(packageDetailsContainer => {

        let pDataCon = packageDetailsContainer;
        // Get their data-package Atrribute
        const packageCode = pDataCon.getAttribute('data-package')
        if (packageCode === "") {
            console.log("package code not found in data-package attribute")
        }

        // Get the package data using packageCode
        let packageData = siteCoachingPackageByCode[packageCode]

        if (packageData == null){
            // Todo: Show error, Could not get package data
            console.log("no package found")
            return
        }

        // We got the packageData, now, use it to set the correct product display price
        const pricePTag = pDataCon.querySelector(".package-duration-amount");

        //  Set the price data for it's child .package-duration-amount
        pricePTag.textContent = packageData.formatted_price;

        // Reset their images .duration-icon-img src to unselected 
        pDataCon.querySelector("img").src = "/static-assets/img/unselected-bullet-point.svg";  
        
        // Remove underline from the package duration text
        const durationPTag = pDataCon.querySelector(".package-duration-text");
        durationPTag.classList.remove("selected-package-decor")


        // Add a click even listener on each .package-details-container with a closure
        pDataCon.addEventListener('click', quickConceptionPackageDetailsClicked(pDataCon));
    });

    
}

// Returns a Closure Event Listener
function quickConceptionPackageDetailsClicked(item) {

    return (event) => {

        // Run when event occurs
        // query all .package-details-container
        document.querySelectorAll('.package-details-container').forEach(packageDetailsContainer => {

            let pDataCon = packageDetailsContainer;

            const pDataConImg = pDataCon.querySelector("img");  

            const durationPTag = pDataCon.querySelector(".package-duration-text");
            
            // Set the global selected package code
            //  If the Event Target item is same as the current packageDetailsContainer
            if (item === pDataCon) {
                //If eventListener is same as this div
                // Would closure work here? or we should take in event object and take.target? (event.target kind of didn't work well. Couldn't get children element by event.target.querySelector("img") So I used closure to lock in item. Maybe using document.querySelector on event.target could work)


                // Get their data-package Atrribute
                const packageCode = pDataCon.getAttribute('data-package')
                if (packageCode === "") {
                    console.log("package code not found in data-package attribute")
                }

                // Set Global packageCode
                QuickConceptionPackageCode = packageCode


                // Set .duration-icon-img src to selected 
                pDataConImg.src = "/static-assets/img/selected-bullet-point.svg";

                // Add selected package decor class
                pDataCon.classList.add("selected-package-decor")
                // durationPTag.classList.add("selected-package-decor")

                
                // We got the packageData, now, use it to set the button
                const claimQuickConceptionPackageButton = document.querySelector(".claim-quick-conception-package");

                let claimPackageButtonText = "Join with ";
                let packageCategory = "VIP";
                let packageDuration = 3;
                let monthText = "months";

                // Check if packageCode contains vip
                if (!(packageCode.toLowerCase().includes("vip"))) {
                    packageCategory = "Standard"
                }

                // Check if it's 2 months or 1 month
                if (packageCode.toLowerCase().includes("2")) {
                    packageDuration = 2;
                } else if (packageCode.toLowerCase().includes("1")) {
                    packageDuration = 1;
                    monthText = "month"
                }

                claimPackageButtonText += packageCategory + " " + packageDuration + " " + monthText;

                //  Set the price data for it's child .package-duration-amount
                claimQuickConceptionPackageButton.textContent = claimPackageButtonText

            } else {

                // Reset their images .duration-icon-img src to unselected 
                pDataConImg.src = "/static-assets/img/unselected-bullet-point.svg";

                // remove the selected-package-decor class
                pDataCon.classList.remove("selected-package-decor")
                // durationPTag.classList.remove("selected-package-decor")
            }

        });


    }
}


/* ===========================================
        Attach Page Engagement Trackers
   ==========================================*/

// qcpackage-selector, section-btn (All have data-target)

export function InitializeQuickConceptionPageTrackingControls() {

    // Add Event Listener to track generic click events
    document.querySelectorAll('.trk_clk_evt').forEach(item => {
        item.addEventListener('click', SubmitTrackedInfo);
    });

    // Add Event Listener to package selectors
    document.querySelectorAll('.qcpackage-selector').forEach(item => {
        item.addEventListener('click', SubmitTrackedInfo);
    });

    // Add Event Listener to all section buttons
    document.querySelectorAll('.section-btn').forEach(item => {
        item.addEventListener('click', SubmitTrackedInfo);
    });

}

async function SubmitTrackedInfo(e) {

    // let eventTarget = e.target;
    // Get data-target property of the event target and 

    // Maybe we could use a general track_click_event or tr_clk_evt

    // target = element which event occured (Events could be propagated).
    // currentTarget = element on which event listener is attached
    let targetInfo = e.currentTarget.getAttribute("data-event");

    return fetch('/page/trackevents/?event='+targetInfo, {
        method: 'POST',
        body: JSON.stringify({page: "quick conception landing page", target: targetInfo}),
        mode: 'cors',
        // redirect:'manual',
        headers: {
            'Content-type': 'application/json; charset=UTF-8',
            'Access-Control-Allow-Origin': '*',
        },
    })
    .then(response => {
        // If server error occurred, throw error
        if (response.status >= 500) {
        throw new Error('Server error');
        }
        return response.json();
    }) .catch(error => {
        // Handle any errors that occur during form submission
        console.error(error);
        return error;
    });
}